import React from "react";
import { Paper } from "@mui/material";

const LabsDetails = ({ lab }) => {
    return (
        <>
            {lab !== null && lab !== undefined && (
                <Paper
                    sx={{
                        paddingLeft: 4,
                        paddingRight: 4,
                        paddingTop: 3,
                        paddingBottom: 3,
                        marginTop: 1,
                        marginBottom: 1,
                        background: "#f2f3f6;",
                        boxShadow: "none",
                    }}
                >
                    <h2 className="labDetailTitle">
                        {lab.LabName}{lab.LabDesc && ` (${lab.LabDesc})`}
                    </h2>
                    <div className="dividerLine" />

                    <div className="labDetailFields">
                        <div className="labDetailFieldsLeft">
                            <div className="labDetailField">
                                <div className="labDetailFieldTitle">Contact</div>
                                <div className="labDetailFieldCopy">
                                    {lab.ContactFirstName} {lab.ContactLastName}
                                </div>
                            </div>
                            <div className="labDetailField">
                                <div className="labDetailFieldTitle">Phone Number</div>
                                <div className="labDetailFieldCopy">
                                    {lab.PhoneNumber}
                                </div>
                            </div>
                            <div className="labDetailField">
                                <div className="labDetailFieldTitle">Email Address</div>
                                <div className="labDetailFieldCopy">
                                    {lab.EmailAddress}
                                </div>
                            </div>
                            {lab.PI && (
                                <div className="labDetailField">
                                    <div className="labDetailFieldTitle">PI</div>
                                    <div className="labDetailFieldCopy">{lab.PI}</div>
                                </div>
                            )}
                        </div>

                        <div className="labDetailFieldsRight">
                            <div className="labDetailField">
                                <div className="labDetailFieldTitle">Shipping Address</div>
                                <div className="labDetailFieldAddress">
                                    {lab.ShippingAddress1 && <p>{lab.ShippingAddress1}</p>}
                                    {lab.ShippingAddress2 && <p>{lab.ShippingAddress2}</p>}
                                    {lab.ShippingAddress3 && <p>{lab.ShippingAddress3}</p>}
                                    {lab.ShippingAddress4 && <p>{lab.ShippingAddress4}</p>}
                                    <p>{lab.ShippingCity}, {lab.ShippingState}{" "}{lab.ShippingPostalCode}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </Paper>
            )}
        </>
    );
};

export default LabsDetails;
